import { CLEAR_ONBOARDING, CurrentRouteActionTypes, IOnboarding, SET_GUIDE_VISIBLE, SET_IS_DRAG, SET_ONBOARDING_INITIAL_DATA, SET_ONBOARING_APP_DETAILS, SET_SERVICE_TASK_EXIST, SET_STAGE_INDEX, SET_STEPS, SET_STEP_INDEX, UPDATE_INITIAL_ONBOARDING_DATA } from "./types"

const initialState: IOnboarding = {
    guideVisible: false,
    appDetails: {},
    info: {
        stepIndex: 0,
        stageIndex: 0,
        guideCompleted: false
    },
    steps: [],
    isDrag: false,
    loading: true,
    isExistServiceTask: false
}
  

export function onboardingReducer(
    state =  initialState,
    action: CurrentRouteActionTypes
): IOnboarding {
    switch (action.type) {
        case SET_STEP_INDEX:{ 
            return {
                ...state,
                info: {
                    ...state.info,
                    stepIndex: action.payload
                }
            }
        }
        case SET_STEPS:{ 
            return {
                ...state,
                steps: action.payload
            }
        }
        case SET_GUIDE_VISIBLE:{ 
            return {
                ...state,
                guideVisible: action.payload
            }
        }
        case SET_STAGE_INDEX:{
            return {
                ...state,
                info: {
                    ...state.info,
                    stageIndex: action.payload,
                    stepIndex: 0
                }
            }
        }
        case SET_ONBOARING_APP_DETAILS:{ 
            return {
                ...state,
                info: {
                    ...state.info,
                    ...action.payload
                }
            }
        }
        case SET_ONBOARDING_INITIAL_DATA: {
            const { payload } = action; 
            let data = payload ? { ...state.info, ...payload } : payload;
            let onboardingInfo = {
                ...state,
                info: data,
                loading: false
            }
            if (!Object.keys(payload).length) {
                onboardingInfo.info.skipTour = true;
            }
            return {
               ...onboardingInfo
            }
        }
        case UPDATE_INITIAL_ONBOARDING_DATA:{
            const { payload } = action; 
            delete payload.stepIndex;
            return {
                ...state,
                info: {
                    ...state.info,
                    ...payload
                }
            }
        }
        case SET_IS_DRAG: {
            const { payload } = action;
            return {
                ...state,
                isDrag: payload
            }
        }
        case CLEAR_ONBOARDING: {

            const { payload } = action;
            return {
                ...state,
                info: payload
            }
        }
        case SET_SERVICE_TASK_EXIST: {
            const { payload } = action;
            return {
                ...state,
                info: {...state.info, isExistServiceTask: payload}
            }
        }
        default:
          return state
      }
}
